import { render, staticRenderFns } from "./DeliveryCell.vue?vue&type=template&id=0f57331e&scoped=true"
import script from "./DeliveryCell.vue?vue&type=script&lang=js"
export * from "./DeliveryCell.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCell.vue?vue&type=style&index=0&id=0f57331e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57331e",
  null
  
)

export default component.exports